import { VisibilityLayoutProps } from './@types/VisibilityLayoutProps';
import { Fragment } from 'react';

const VisibilityLayout = ({ visible = true, children }: VisibilityLayoutProps) =>
	visible === false ? null : <Fragment>{children}</Fragment>;

export default VisibilityLayout;
